import {
    useCallback, useMemo,
} from 'react'
import {
    useQueryClient,
} from '@tanstack/react-query'
import {
    useDispatch,
} from 'react-redux'
import {
    RequestConfigFunction,
} from 'app/types/request.types'
import {
    useJWTToken,
} from 'app/Auth'
import {
    RequestKeys, RequestFn,
} from 'app/hooks/useRequest'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

export default ({
    name,
    requestKey,
    requestFn,
}: {
    name: string,
    requestKey: RequestKeys,
    requestFn: RequestConfigFunction
}): <Response = any, Params = Record<string, any>>(params: Params) => Promise<Response> => {
    const queryClient = useQueryClient()
    const token = useJWTToken()
    const dispatch = useDispatch()

    const {
        onError,
    } = useHandleStatusRequest({
        id: name,
    })

    const queryFn = useMemo(() => {
        return RequestFn.getEntity(requestFn)(dispatch)
    }, [
        dispatch,
        requestFn,
    ])

    return useCallback(async (params: Record<string, any>) => {
        let data

        const queryKey = [
            requestKey,
            {
                ...params,
                token,
            },
        ]

        try {
            data = await queryClient.fetchQuery({
                queryKey,
                queryFn,
                staleTime: 100000,
            })
        } catch (error) {
            onError(error)
        }

        return data
    }, [
        onError,
        queryClient,
        queryFn,
        requestKey,
        token,
    ])
}
